import styled, { keyframes } from "styled-components"

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const CareerWrapp = styled.div`
  background: #f7f5f0;
  min-height: 100vh;
  
  .career {
    padding-top: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    min-height: calc(100vh - 120px);

    .content {
      width: 100%;
      max-width: 980px;
      text-align: center;
      padding: 40px 24px;
      animation: ${fadeInUp} 0.6s ease-out;

      h1 {
        font-size: 3.8rem;
        color: #17201b;
        margin-bottom: 18px;
        line-height: 1.12;
        font-weight: 700;
        letter-spacing: 0;
      }

      p {
        font-size: 15px;
        color: #5f6670;
        margin: 0 auto 10px;
        line-height: 1.6;
        max-width: none;
        white-space: nowrap;
      }

      .features {
        display: flex;
        gap: 14px;
        justify-content: center;
        margin: 34px 0;
        flex-wrap: wrap;

        .feature {
          background: #fbfaf7;
          border: 1px solid #e7e2d8;
          border-radius: 8px;
          padding: 18px;
          width: 190px;

          .icon {
            width: 28px;
            height: 28px;
            display: block;
            margin: 0 auto 14px;
            position: relative;
            color: #5f7967;
          }

          .icon-match {
            border: 2px solid currentColor;
            border-radius: 50%;

            &::after {
              content: "";
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background: currentColor;
              position: absolute;
              top: 8px;
              left: 8px;
            }
          }

          .icon-ai {
            border: 2px solid currentColor;
            border-radius: 8px;

            &::before,
            &::after {
              content: "";
              width: 4px;
              height: 4px;
              border-radius: 50%;
              background: currentColor;
              position: absolute;
              top: 10px;
            }

            &::before {
              left: 7px;
            }

            &::after {
              right: 7px;
            }
          }

          .icon-insight {
            &::before {
              content: "";
              position: absolute;
              inset: 4px;
              border-left: 2px solid currentColor;
              border-bottom: 2px solid currentColor;
            }

            &::after {
              content: "";
              position: absolute;
              width: 18px;
              height: 12px;
              border-top: 2px solid currentColor;
              border-right: 2px solid currentColor;
              transform: rotate(-35deg);
              left: 6px;
              top: 7px;
            }
          }

          h3 {
            color: #28342f;
            font-size: 14px;
            font-weight: 600;
            margin: 0;
          }
        }
      }

      .btn {
        font-size: 15px;
        font-weight: 600;
        padding: 13px 28px;
        cursor: pointer;
        margin-top: 12px;
        border: none;
        border-radius: 8px;
        background: #28342f;
        color: white;
        box-shadow: none;
        transition: background 0.2s ease, transform 0.2s ease;
        
        &:hover {
          transform: translateY(-1px);
          background: #5f7967;
        }
        
        &:active {
          transform: translateY(0);
        }
      }
      
      .powered-by {
        margin-top: 32px;
        color: #7b817b;
        font-size: 13px;
        
        span {
          background: #ebe6db;
          color: #28342f;
          padding: 4px 10px;
          border-radius: 8px;
          margin-left: 8px;
        }
      }
    }
  }
  
  @media (max-width: 768px) {
    .career {
      .content {
        padding: 30px 20px;
        
        h1 {
          font-size: 3rem;
        }
        
        p {
          font-size: 14px;
          white-space: normal;
        }
        
        .features {
          gap: 15px;
          
          .feature {
            width: 100%;
            max-width: 280px;
            padding: 18px;
          }
        }
        
        .btn {
          width: 100%;
          max-width: 300px;
        }
      }
    }
  }
`
